import { uploadImage } from '@screens/Product';
import { REVIEW_IMAGES_PATH } from '@shared/config/paths/paths';

export const uploadReviewImages = async (productId: string, files: File[]) => {
  const responses = await Promise.all(
    files.map((image) => {
      const formData = new FormData();

      formData.append('image', image, encodeURI(image.name));

      return uploadImage(productId, formData);
    })
  );

  return responses.map(({ path }) => `${REVIEW_IMAGES_PATH}/${path}`);
};
